import React, { useEffect, useState, useRef } from "react";
import Player from "@vimeo/player"; // ✅ Vimeo SDK import
import "./404.css";

const NotFoundPage = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [loading, setLoading] = useState(false);


  const videoRef = useRef(null); // ✅ Ref for Vimeo SDK container



  // ✅ Initialize Vimeo Player
  useEffect(() => {
    if (videoRef.current) {
      const player = new Player(videoRef.current, {
        url: "https://vimeo.com/1079069666/ada49f95c5", // full video URL with hash
        autoplay: false,
        loop: false,
        muted: false,
        responsive: true,
      });

      return () => player.destroy();
    }
  }, []);





  return (
    <div className="app-container">
      {/* ✅ LEFT SECTION */}
      <div className="left-section">
       <div className="branding">
  <a href="https://sendnow.live" target="_blank" rel="noopener noreferrer">
    <img
      src="/sendnow_login_logo.svg"
      alt="SendNow Logo"
      className="logo-image"
      style={{ cursor: "pointer" }}
    />
  </a>
</div>


        <div className="card">
           <div className="video-heading">
      <h2>All About Sendnow</h2>
      <p>covering everything from upload to tracking</p>
    </div>
          <div
            style={{
              width: "100%",
            
              borderRadius: "10px",
              overflow: "hidden",
              position: "relative",
              boxShadow: "15px 15px 30px rgba(0, 0, 0, 0.5)", // ✅ Deeper shadow
    border: "3px solid #e0e0e0", // ✅ Light gray border on all sides // ⬆️ Stronger shadow for elevation
             
            }}
          >
            <div
              ref={videoRef}
              style={{
                width: "100%",
                height: "100%",
              }}
            ></div>
          </div>
        </div>
      </div>

      {/* ✅ RIGHT SECTION */}
      <div className="right-section-login">
        <div className="auth-box">
          <p className="auth-title">Upload Share and Get Analytics with Shorten URL</p>
          <button className="google-button" disabled={loading}  onClick={() => {
   
      window.location.href = "https://www.sendnow.live";
    
  }}>
            <img
              src="/sendnowlogo.png"
              alt="google icon"
              className="google-icon"
            />
            Continue with Sendnow
          </button>
          <div className="divider"><span>or</span></div>
          <div className="features">
            <ul>
              <li>✓ Share up to 3 links with ease</li>
              <li>✓ Upload files up to 50MB</li>
              <li>✓ Supports Links, PDFs, Docs, and Videos</li>
              <li>✓ Instant URL shortening</li>
              <li>✓ Essential analytics at your fingertips</li>
              <li>✓ Links stay active for 7 days</li>
            </ul>
          </div>
          <p className="terms">
            By signing in, you agree to our{" "}
            <a
              href="https://www.sendnow.live/terms-and-conditions"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Service
            </a>{" "}
            and{" "}
            <a
              href="https://www.sendnow.live/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage
